import { Close, SaveOutlined } from '@mui/icons-material'
import type { ButtonProps } from '@mui/material'
import { DialogActions, Stack } from '@mui/material'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import CustomButton from '@/components/inputs/CustomButton'

type FormDialogActionsProps = {
  isLoading?: boolean
  /** Overrides for non-default (e.g. destructive) submit buttons; each falls back to the Save defaults. */
  submitLabel?: string
  submitColor?: ButtonProps['color']
  submitIcon?: ReactNode
  /** Disables submit on top of `isLoading`, e.g. while the form is invalid. */
  submitDisabled?: boolean
  onCancel: () => void
  onSubmit?: () => void
}

const FormDialogActions = ({
  isLoading,
  submitLabel,
  submitColor = 'primary',
  submitIcon,
  submitDisabled,
  onCancel,
  onSubmit,
}: FormDialogActionsProps) => {
  const { t } = useTranslation()

  return (
    <DialogActions>
      <Stack sx={{ flexDirection: 'row', gap: 1 }}>
        <CustomButton
          color={submitColor}
          disabled={isLoading || submitDisabled}
          startIcon={submitIcon ?? <SaveOutlined />}
          type={onSubmit ? 'button' : 'submit'}
          variant="contained"
          onClick={onSubmit}
        >
          {submitLabel ?? t('common.button.save')}
        </CustomButton>
        <CustomButton
          color="primary"
          disabled={isLoading}
          startIcon={<Close />}
          type="reset"
          variant="outlined"
          onClick={onCancel}
        >
          {t('common.button.cancel')}
        </CustomButton>
      </Stack>
    </DialogActions>
  )
}

export default FormDialogActions
